module.exports = __webpack_public_path__ + "static/media/ALevel_subjects.5c8bf742.png";